import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import apiRoutes from '../../../app/api/routes';

export const REMOVE_ORG_APP_SUBSCRIPTION_RESOURCE = 'removeOrgAppSubscription';

const removeOrgAppSubscriptionService = ComposedComponent =>
  reduxFetch([
    {
      resource: REMOVE_ORG_APP_SUBSCRIPTION_RESOURCE,
      method: 'delete',
      request: (body, subscriptionId, callback, resource, t) => ({
        url: apiRoutes.organisationApps(),
        body,
        meta: {
          callback,
          removeFromOtherList: {
            resource,
            idProp: 'subscriptionId',
            id: subscriptionId,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'removeOrgSubscriptionFailed'),
            onSuccessMessage: t('removeOrgSubscriptionSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default removeOrgAppSubscriptionService;
